import { PimAttribute } from "@dataspecer/core/pim/model";
import { loadSgovEntityToResource } from "./sgov-entity-adapter.js";
import { POJEM, RDFS } from "../sgov-vocabulary.js";
import { loadSgovCardinalities } from "./sgov-resource-cardinality-adapter.js";
export async function isSgovAttribute(entity) {
    return (await entity.types()).includes(POJEM.typVlastnosti);
}
export async function loadSgovAttribute(entity, idProvider) {
    const result = new PimAttribute();
    await loadSgovEntityToResource(entity, idProvider, result);
    await loadSgovCardinalities(entity, result);
    result.pimOwnerClass = idProvider.cimToPim(await entity.node(RDFS.domain));
    return result;
}
//# sourceMappingURL=sgov-attribute-adapter.js.map